<template>
    <header class="header">
        <div class="shell">
            <base-button @click="goBack" v-if="showBackButton">
                <icon-chevron-left />
            </base-button>

            <p :class="{'offset-left': showBackButton}">
                {{title}}
            </p>
        </div>
    </header>
</template>

<script>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router'
import BaseButton from '@/components/base-button/base-button';
import IconChevronLeft from '@/components/icons/icon-chevron-left/icon-chevron-left';

export default {
    name: 'BaseHeader',

    components: {
        BaseButton,
        IconChevronLeft
    },

    setup() {
        const route = useRoute();
        const router = useRouter();

        const goBack = () => {
            router.back()
        }

        return {
            title: computed(() => route.meta.title),
            showBackButton: computed(() => !!route.meta.showBack),
            goBack
        }
    }
}
</script>
